import Vue from "vue";
import Router from "vue-router";

// Containers
const DefaultContainer = () => import("@/containers/DefaultContainer");
const CleanContainer = () => import("@/containers/CleanContainer");

// Views
const Dashboard = () => import("@/views/Dashboard");
const DocumentsList = () => import("@/views/Documents/List");
const DocumentsManage = () => import("@/views/Documents/Manage");
const LabelsList = () => import("@/views/Labels/List");
const LabelsManage = () => import("@/views/Labels/Manage");
const DocumentsConfigurations = () => import("@/views/Documents/Configurations");

const Login = () => import("@/views/Auth/Login");
const Register = () => import("@/views/Auth/Register");

const Page404 = () => import('@/views/Pages/404')

Vue.use(Router);

export default new Router({
  mode: "hash",
  linkActiveClass: "open active",
  routes: [
    {
      path: "/auth",
      name: "Auth",
      component: CleanContainer,
      children: [
        {
          path: "login",
          name: "Login",
          component: Login
        }
      ]
    },
    {
      path: "/",
      name: "Home",
      component: DefaultContainer,
      meta: { auth: true },
      children: [
        {
          path: "dashboard",
          name: "Dashboard",
          component: Dashboard
        }
      ]
    },
    {
      path: "/documents",
      name: "Documents",
      component: DefaultContainer,
      meta: { auth: true },
      children: [
        {
          path: "list",
          name: "List",
          component: DocumentsList
        },
        {
          path: "manage",
          name: "Manage",
          component: DocumentsManage
        },
        {
          path: "configurations",
          name: "Configurations",
          component: DocumentsConfigurations
        }
      ]
    },
    {
      path: "/labels",
      name: "Labels",
      redirect: "/labels/list",
      component: DefaultContainer,
      meta: { auth: true },
      children: [
        {
          path: "list",
          name: "List",
          component: LabelsList
        },
        {
          path: "manage",
          name: "Manage",
          component: LabelsManage
        }
      ]
    },
    { path: "*", component: Page404 }
  ]
});
